import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const SectionContainer = styling("div")((props) => ({
  width: "100%",
  flexDirection: "column",
  alignItems: "flex-start",
  background: "#262626",

  [props.theme.breakpoints.down("lg")]: {
    flexShrink: "0",
  },

  [props.theme.breakpoints.down("tablet")]: {
    flexShrink: "0",
  },
}));

export const InnerSectionContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "40px",
  alignSelf: "stretch",
  width: "100%",
  maxWidth: "1440px",
  margin: "auto",
  padding: "80px 100px 140px 100px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "48px 24px 180px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "56px 24px",
    gap: "24px",
  },
}));

export const BoxStyled = styling(Box)((props) => ({}));

export const ImageBoxStyled = styling(Box)((props) => ({
  width: "235px",
  height: "88px",
  padding: "12px 0px",

  [props.theme.breakpoints.down("lg")]: {
    width: "80px",
    height: "80px",
    padding: "0px",
  },
}));

export const CardStyled = styling(Box)((props) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  padding: "32px 40px",
  flex: "1 0 0",
  height: "100%",
  minHeight: "368px",
  gap: "16px",
  borderRadius: "10px",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    padding: "16px",
    alignItems: "flex-start",
  },

  [props.theme.breakpoints.down("tablet")]: {
    alignItems: "center",
    alignSelf: "stretch",
    flexDirection: "column",
    minHeight: "550px",
  },
}));

export const TitleContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  width: "100%",
}));

export const SubTitleContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

export const TextStyled = styling(Typography)((props) => ({
  color: "rgba(255, 255, 255, 0.87)",
  fontFamily: props.type == "desc" ? "Inter" : "Georgia",
  fontSize: props.type == "desc" ? "20px" : "40px",
  fontWeight: props.type == "desc" ? "400" : "400",
  lineHeight: props.type == "desc" ? "24px" : "48px",
  flex: props.type == "desc" ? "none" : "1 0 0",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props.type == "desc" ? "18px" : "30px",
    lineHeight: props.type == "desc" ? "21.6px" : "36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "22.4px" : "28.8px",
  },
}));

export const CardTextStyled = styling(Typography)((props) => ({
  color: props.type == "desc" ? "rgba(0, 0, 0, 0.60)" : "rgba(0, 0, 0, 0.87)",
  fontSize: props.type == "desc" ? "20px" : "28px",
  fontWeight: props.type == "desc" ? "400" : "500",
  letterSpacing: props.type == "desc" ? "unset" : "0.14px",
  lineHeight: props.type == "desc" ? "30px" : "normal",
  fontFamily: props.type == "desc" ? "Inter" : "Manrope",
  alignSelf: props.type == "desc" ? "stretch" : "unset",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props.type == "desc" ? "16px" : "28px",
    lineHeight: props.type == "desc" ? "24px" : "normal",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "24px" : "28.8px",
    fontWeight: props.type == "desc" ? "400" : "600",
  },
}));

export const TextOther = styling(Typography)((props) => ({
  alignSelf: "stretch",
  color: "#A995E9",
  fontFamily: "Manrope",
  fontSize: "20px",
  fontWeight: "600",
  lineHeight: "24px",
  letterSpacing: "0.3px",

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "14px",
    lineHeight: "16.8px",
    letterSpacing: "0.21px",
    fontWeight: "500",
  },
}));

export const ImageStyled = styling("img")({
  objectFit: "contain",
  height: "100%",
  width: "100%",
  // maxHeight: "95px",
  // maxWidth: "95px",
});

export const CoverImageStyled = styling("img")((props) => ({
  objectFit: "cover",
  height: "100%",
  width: "100%",
  maxHeight: "305px",
  maxWidth: "405px",
  borderRadius: "8px",

  [props.theme.breakpoints.down("lg")]: {
    // maxWidth: "250px",
    maxHeight: "190px",
  },
}));

export const ButtonStyled = styling("button")((props) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  background: props?.white ? "#FFF" : "#2e2e2e",
  color: props?.white ? "#2e2e2e" : Color.white,
  borderRadius: "100px",

  fontSize: "16px",
  fontWeight: 700,
  textDecoration: "none",
  whiteSpace: "nowrap",

  height: "48px",
  width: "200px",

  transition: "all 0.3s ease-in-out",
  cursor: "pointer",

  "@media (min-width: 1280px)": {
    "&:hover": {
      background: props?.white ? "#FFF" : "#222",
      color: props?.white ? "#2e2e2e" : "#FFF",
    },
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "280px",
  },
}));
